import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TemplateRequestInterface } from '../../interfaces/template-request.interface';
import { SaveTemplateRequestInterface } from '../../interfaces/save-template-request.interface';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';
import { GenerateTemplateResponseInterface } from '../../interfaces/generate-template-response.interface';
import { TemplateResponseInterface } from '../../interfaces/template-response.interface';
import { LegDestinationInterface } from '@modules/service-request-template/interfaces/leg-destination.interface';

@Injectable()
export class TemplateService {
  private readonly url = `${environment.apiUrl}/Template`;

  constructor(private readonly httpClient: HttpClient) {}

  getTemplateById(templateId: string): Observable<TemplateResponseInterface> {
    return this.httpClient.get<TemplateResponseInterface>(`${environment.apiHostV2}/Templates/GetTemplateTextById/${templateId}`);
  }

  getMembersByServiceRequest(serviceRequestId: string): Observable<BaseDropdownInterface[]> {
    return this.httpClient.get<BaseDropdownInterface[]>(`${this.url}/GetMembersByServiceRequest/${serviceRequestId}`);
  }

  getReadDestinationsForLegs(legIds: string[]): Observable<LegDestinationInterface> {
    const body = {
      legIds,
    };

    return this.httpClient.post<LegDestinationInterface>(`${this.url}/ReadDestinationsForLegs`, body);
  }

  generateTemplate(body: TemplateRequestInterface): Observable<GenerateTemplateResponseInterface> {
    return this.httpClient.post<GenerateTemplateResponseInterface>(`${this.url}/GenerateDriverTemplate`, body);
  }

  saveTemplate(body: SaveTemplateRequestInterface): Observable<null> {
    return this.httpClient.post<null>(`${this.url}/SaveDriverTemplate`, body);
  }
}
